@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.verified-quantity-count {
  background-color: @scan-page--item-list-unverified-row-scanned-count--background-color;
  border: 1px solid @scan-page--item-list-unverified-row-scanned-count--border-color;
  box-shadow: 0 1px @scan-page--item-list-unverified-row-scanned-count--box-shadow--color;
}

.row-cell {
  transition: background-color 200ms ease;
  box-shadow: 0 2px 1px @scan-page--item-list-unverified-row--box-shadow--color;

  &.verifying {
    background-color: @scan-page--item-list-unverified-row-verifying--background-color;
  }
  &.dont-verify {
    background-color: @scan-page--item-list-unverified-row-dont-verify--background-color;
  }
}

.adjusted-to-zero {
  background-color: @scan-page--item-list-unverified-row-adjusted--background-color;
}
